// 防抖 一段时间内连续触发只会执行最后一次
export const debounce = (fn, delay = 1000) => {
  let timeout = null;
  return function() {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      fn.apply(this, arguments);
    }, delay);
  }
}

// 节流 一个时间周期内只会执行一次，直到下一个时间周期
export const throttle = (fn, delay = 1000) => {
  let timeout = null;
  return function() {
    if (timeout) return;
    timeout = setTimeout(() => timeout = null, delay);
    fn.apply(this, arguments);
  }
}


// 使用
// 需要手动引入，在methods中无法使用this.$utils获取方法
// import { debounce, throttle } from '@/utils';

// 在methods中使用
// methods: {
//   handleFn: debounce((params) => { // 参数fn使用箭头函数，在箭头函数中无法获取this，可以获取params
//     ...处理函数
//   }, delay),
//   handleFn: throttle(function(params) { // 参数fn使用匿名函数，匿名函数中可以获取this与params
//     ...处理函数
//   }, delay),
// }